import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import NamedRoute from './NamedRoute';
import AuthService from '../../services/AuthService';

const EmptyRoute = ({
  component: Component,
  forBothAuthStates,
  title,
  description,
  ...childProps
}) => {
  return (
    <NamedRoute
      title={title}
      description={description}
      render={() => {
        if (forBothAuthStates) {
          return <Component {...childProps} />;
        }
        return AuthService.isAuthenticated() ? (
          <Navigate replace to="/" />
        ) : (
          <Component {...childProps} />
        );
      }}
    />
  );
};

EmptyRoute.propTypes = {
  component: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.string,
  render: PropTypes.func,
  description: PropTypes.string,
  scriptType: PropTypes.string,
  keywords: PropTypes.string,
  forBothAuthStates: PropTypes.bool,
};

export default EmptyRoute;
